export enum ImageLocations {
  Goals = 'uploads/goal',
  Vision = 'uploads/vision',
}
